import authHeader from '@/api/auth-header'
import axios from 'axios'

export function getRatingCoaches() {
  return axios.get('userdata/rating-admission/coaches/', {
    headers: authHeader(),
  }).then(response => response.data)
}

export function updateRatingCoach(id, payload) {
  return axios.patch(`userdata/rating-admission/coaches/${id}/update/`, payload, {
    headers: authHeader(),
  }).then(response => response.data)
}

export function getRatingCriteria(params) {
  return axios.get('userdata/rating-admission/criteria/', {
    headers: authHeader(),
    params,
  }).then(response => response.data)
}

export function createRatingCriterion(payload) {
  return axios.post('userdata/rating-admission/criteria/create/', payload, {
    headers: authHeader(),
  }).then(response => response.data)
}

export function getRatingLabels(companyId) {
  return axios.get('userdata/rating-admission/labels/', {
    headers: authHeader(),
    params: { company_id: companyId },
  }).then(response => response.data)
}

export function getRatingPreview({ companyId, ycLabelId }) {
  return axios.get('userdata/rating-admission/preview/', {
    headers: authHeader(),
    params: {
      company_id: companyId,
      yc_label_id: ycLabelId,
    },
  }).then(response => response.data)
}

export function getRatingCriterion(id) {
  return axios.get(`userdata/rating-admission/criteria/${id}/`, {
    headers: authHeader(),
  }).then(response => response.data)
}

export function updateRatingCriterion(id, payload) {
  return axios.patch(`userdata/rating-admission/criteria/${id}/update/`, payload, {
    headers: authHeader(),
  }).then(response => response.data)
}

export function deleteRatingCriterion(id) {
  return axios.delete(`userdata/rating-admission/criteria/${id}/delete/`, {
    headers: authHeader(),
  })
}
